module.exports = __webpack_public_path__ + "static/media/Hyaluron_Collagen_komplex_kapky_retina.fae1d0a3.png";